import { useEffect } from 'react';
import { connect } from 'react-redux';
import {enableSquareFootage} from "../../actions/sqftFunctions";

const SquareFootageToolPage = (props) => {
  const { enableSquareFootage, isModalFixOpen } = props
  useEffect(() => {
    enableSquareFootage(true);
    return () => {
      if (!isModalFixOpen) {
        enableSquareFootage(false);
      }
    };
  }, [enableSquareFootage, isModalFixOpen]);

  return null;
};

const mapStateToProps = (store) => ({
  isModalFixOpen: store.sqftModalFixState.isModalFixOpen,
});

const mapDispatchToProps = {
  enableSquareFootage,
};

export default connect(mapStateToProps, mapDispatchToProps)(SquareFootageToolPage);
